<template>
    <Head title="Dashboard: Аналитика авансовых балансов"/>

    <authenticated-layout :notifications="notifications" >

        <v-navigation />

        <div v-if="success" class="flex flex-col bg-white p-4">


            <form class="grid grid-cols-6 px-6 pb-6 pt-2 gap-2 items-end"
                  @submit.prevent="update">
                <h1 class="col-span-3 text-lg pb-4">Аналитика авансовых балансов</h1>
                <v-input label="Дата начала" type="date" v-model="date.from"/>
                <v-input label="Дата окончания" type="date" v-model="date.to"/>
                <div class="flex flex-row justify-between items-center">
                  <v-button color="green">Обновить</v-button>
                  <a class="text-blue-700" target="_blank" :href="route('download.advanced.analytics', {...date})">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"/>
                    </svg>
                  </a>
                </div>
            </form>

            <div class="grid grid-cols-12 gap-x-6 px-6 items-end text-sm font-bold">
                <span class="col-span-3 row-span-2">ID авансового, Организация</span>
                <span class="text-center col-span-2">Баланс</span>
                <span class="text-right row-span-2">Приход</span>
                <span class="text-right row-span-2">Расход</span>
                <span class="text-right row-span-2">Возврат</span>
                <span class="text-center col-span-4">Комиссия</span>
                <span class="text-right">В начале</span>
                <span class="text-right">В конце</span>
                <span class="text-right">блокчейна</span>
                <span class="col-span-3">по тарифам</span>
            </div>

            <div v-for="(r, id) of result"  class="grid grid-cols-12 gap-6 py-2 px-6 border-t text-sm">
                <div class="col-span-3 flex flex-col text-xs">
                    <span>{{ id }}</span>
                    <Link
                        v-if="r.owner && r.owner.id"
                        class="text-blue-700 text-sm"
                        :href="route('organization.advanced', r.owner.id)"
                    >{{ r.owner.name }}</Link>
                </div>
                <span class="text-right font-mono">{{ r.startBalance }}</span>
                <span class="text-right font-mono">{{ r.endBalance }}</span>
                <span class="text-right font-mono">{{ r.incr }}</span>
                <span class="text-right font-mono">{{ r.decr }}</span>
                <span class="text-right font-mono">{{ r.refund }}</span>
                <span class="text-right font-mono">{{ r.blockchainFees }}</span>
                <div class="col-span-3">
                    <div v-show="r.tariffShow || false" v-for="(rt, i) of r.tariffFees">
                        <div class="grid grid-cols-4 text-xs" :class="(i % 2) ? '' : 'bg-gray-100'">
                            <div class="col-span-2">{{ rt.type }}</div>
                            <div>
                                <span v-if="rt.currencyId && currencies[rt.currencyId]">{{ currencies[rt.currencyId].name ||  '' }}</span>
                                <span v-if="rt.networkId && networks[rt.networkId]">({{ networks[rt.networkId].name ||  '' }})</span>
                            </div>
                            <div class="text-right font-mono">{{ rt.amount }}</div>
                        </div>
                    </div>
                    <div class="grid grid-cols-3">
                        <span class="col-span-2 text-blue-700 cursor-pointer" @click="r.tariffShow = !r.tariffShow">
                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                                <path v-if="r.tariffShow || false" fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                                <path v-else fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                            </svg>
                        </span>
                        <span class="text-right font-mono">
                            {{ r.tariffFees.reduce((a, b) => a.plus(b.amount), new BigNumber(0)) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-12 border-t-2 gap-6 py-2 px-6 text-sm">
                <span class="col-span-5 fond-bold">Сумма</span>
                <span class="text-right font-mono">{{ total.incr }}</span>
                <span class="text-right font-mono">{{ total.decr }}</span>
                <span class="text-right font-mono">{{ total.refund }}</span>
                <span class="text-right font-mono">{{ total.blockchainFees }}</span>
                <span class="col-span-3 text-right font-mono">{{ total.tariffFees }}</span>
            </div>
        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Dashboard';
import VButton from '@/Components/Button';
import VInput from "@/Components/Input.vue";
const BigNumber = require("bignumber.js");

export default {
    components: {
        VInput,
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VButton,
    },
    props: {
        success: Boolean,
        result: Object,
        notifications: Array,
        currencies: Object,
        networks: Object,
        date: Object,
    },
    methods: {
        update() {
            useForm(this.date).get(this.route('dashboard.advanced.analytics'))
        },
    },
    computed: {
        BigNumber() {
            return BigNumber
        },
        total() {
            const total = {
                incr: new BigNumber(0),
                decr: new BigNumber(0),
                refund: new BigNumber(0),
                blockchainFees: new BigNumber(0),
                tariffFees: new BigNumber(0)
            }
            for (const r of Object.values(this.result)) {
                total.incr = total.incr.plus(r.incr);
                total.decr = total.decr.plus(r.decr);
                total.refund = total.refund.plus(r.refund);
                total.blockchainFees = total.blockchainFees.plus(r.blockchainFees);
                total.tariffFees = total.tariffFees.plus(r.tariffFees.reduce((a, b) => a.plus(b.amount), new BigNumber(0)))
            }
            return total;
        }
    },
}
</script>
